import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ConfirmationService, MessageService } from '@openng/optimus-ui/api';
import { BaseTemplateEditorComponent } from './base-template-editor.component';
import { TEMPLATE_EDITOR_IMPORTS } from './template-editor.imports';

/**
 * The single concrete editor component. It owns the shared template, so that
 * 1300+ line template is type-checked once instead of once per channel.
 *
 * Each channel is a thin wrapper that renders <app-template-editor> with the
 * inputs that describe what differs for that channel (see the @Input()s on
 * BaseTemplateEditorComponent).
 */
@Component({
    selector: 'app-template-editor',
    imports: [...TEMPLATE_EDITOR_IMPORTS],
    providers: [ConfirmationService, MessageService],
    templateUrl: './template-editor.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './base-template-editor.component.scss'
})
export class TemplateEditorComponent extends BaseTemplateEditorComponent {}
